/* 🤖 this file was generated by svg-to-ts */
export const siriusLeaf: {
  name: 'leaf';
  data: string;
} = {
  name: 'leaf',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.065 17.874c-2.074-3.84-1.624-7.74 1.042-10.604C8.845 4.33 13.79 2.62 20.294 3.001a.75.75 0 0 1 .705.705c.382 6.505-1.329 11.45-4.27 14.187-2.863 2.666-6.763 3.116-10.603 1.042L4.28 20.78a.75.75 0 0 1-1.06-1.061l1.845-1.846Zm1.114-1.113 8.29-8.291a.75.75 0 1 1 1.061 1.06l-8.29 8.292c3.188 1.558 6.22 1.065 8.468-1.027 2.406-2.24 4.039-6.437 3.825-12.328-5.89-.214-10.087 1.419-12.328 3.825-2.092 2.247-2.585 5.28-1.026 8.469Z" fill="currentColor"/></svg>`
};
